// @flow
import React from 'react';
import { get } from 'lodash';

import { constants, messageFormat } from '@clubmed/utils';
import { getProductBadgeIcon, isExclusiveCollection } from 'Components/utils/product/product.utils';

import { type MultimediaResources } from 'Components/widgets/multimedia/Multimedia.jsx';
import { ProductImmersive } from 'Components/widgets/product-immersive/ProductImmersive.jsx';

const { PRODUCT_TYPES } = constants;

type Props = {
  config: CMSContent,
  cruise: {|
    fromToDestination: string,
  |},
  id?: string,
  media: MultimediaResources,
  resort: Resort,
  socialPictures: Array<SocialPicture>,
};

function getProductInfos({ dateRange, duration, destination = {}, fromToDestination, type }) {
  const { country, area } = destination;

  switch (type) {
    case PRODUCT_TYPES.TOUR:
      return [duration].filter(Boolean);
    case PRODUCT_TYPES.CRUISE:
      return [fromToDestination, dateRange].filter(Boolean);
    default:
      return [country, area].filter(Boolean);
  }
}

export function ProductImmersiveLine({
  config = {},
  cruise,
  id,
  media,
  resort,
  socialPictures,
}: Props) {
  const { comfort, images = [], name, type } = resort;

  const productGallery = get(config, 'common.galleries.productGallery');
  const gallery = get(config, 'common.galleries.gallery');

  return (
    <ProductImmersive
      badgeIcon={getProductBadgeIcon(resort)}
      className="Line Line-Immersive"
      closeLabel={get(config, 'common.close')}
      galleryLabel={
        name && productGallery
          ? messageFormat(productGallery).format({ productName: name })
          : gallery
      }
      hasInsetBorder={isExclusiveCollection(type, comfort)}
      id={id}
      infos={getProductInfos({ ...resort, ...cruise })}
      media={images}
      multimedia={{ ...media, socialPictures }}
      multimediaLabels={{
        photos: get(config, 'common.photoTitle'),
        socialPictures: get(config, 'common.socialPicturesTitle'),
        videos: get(config, 'common.videoTitle'),
        videos360: get(config, 'common.video360Title'),
      }}
      nextLabel={get(config, 'common.next')}
      previousLabel={get(config, 'common.previous')}
      title={name}
    />
  );
}
